import { render } from "./SocialLinks.vue?vue&type=template&id=eee04e12"
const script = {}

import "./SocialLinks.vue?vue&type=style&index=0&id=eee04e12&lang=css"
script.render = render

export default script